<template>
    <div class="featured-content">
        <!--课程首页-->
        <el-scrollbar >
            <div class="featured">
                <div class="main">
                    <div class="top-box">
                <div class="top-leftBox">
                    <img v-if="courseInfos.course_cover !== null" :src="courseInfos.course_cover" alt="">
                    <img v-else src="../../../assets/img/image/s_course_bg.png" alt="">
                </div>
                <div class="top-rightBox">
                    <div class="rightBox-course">
                        <div class="course-title-box1">{{courseInfos.course_name}}</div>
                        <!-- <div class="course-title-box2" v-if="courseInfos.course_type === 1">
                            <i class="iconfont">&#xe60d;</i>精品课程
                        </div> -->
                    </div>
                    <div class="rightBox-course">
                        <div class="course-title-midBox">
                            课程分类：<span>{{courseInfos.rc_name}}</span>
                        </div>
                    </div>
                    <div class="rightBox-course" style="display: flex; width: 450px; justify-content: space-between;">
                        <div class="course-title-midBox">
                            任务：<span>{{classObject.task_num}}</span>
                        </div>
                        <div class="course-title-midBox">
                            团队：<span>1</span>
                        </div>
                        <div class="course-title-midBox">
                            学员数：<span>{{classObject.s_num}}</span>
                        </div>
                        <div class="course-title-midBox">
                            进度：<span>{{ classObject.progress }}</span>
                        </div> <div class="course-title-midBox">
                            邀请码：<span>{{classObject.invitation_code}}</span>
                        </div>
                    </div>
                    <div class="rightBox-course">
                        <div class="course-title-midBox course-title-midBox1">
                            课程简介：<span>{{courseInfos.course_desc}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-box">
                <div class="course-list">
                    <div v-if="course_video.length > 0" class="list-item" @click="viewFile(course_video[0])">
                        <img src="../../../assets/teacherIcon/left1.png" alt="">
                        <span>课程视频导读</span>
                    </div>
                    <div class="list-item" @click="viewCourseDetail">
                        <img src="../../../assets/teacherIcon/course-detail.png" alt="">
                        <span>课程详情介绍</span>
                    </div>
                    <div v-if="courseInfo.fishbone_map.length && courseInfo.fishbone_map.length > 0" class="list-item"
                         @click="viewFishBone">
                        <img src="../../../assets/teacherIcon/fish-bone.png" alt="">
                        <span>鱼骨图</span>
                    </div>
                    <div v-if="courseInfo.knowledge_map.length && courseInfo.knowledge_map.length > 0" class="list-item"
                         @click="viewKnowledge">
                        <img src="../../../assets/teacherIcon/knowledge-domain.png" alt="">
                        <span>知识图谱</span>
                    </div>
                     <div class="list-item" @click="viewFile(item)"
                         v-for="(item,index) in courseInfo.files_data"
                         :class="item.class">
                        <img v-if="item.src" :class="'img'+index" :src="item.src" alt="">
                        <img v-else :class="'img'+index" src="@/assets/teacherIcon/lab-report.png" alt="">
                        <span>{{item.name}}</span>
                    </div>
                </div>
            </div>
                </div>
            </div>
        </el-scrollbar>
        <el-dialog
                title="知识图谱"
                :visible.sync="knowledgeVisible"
                :before-close="handleCloseKnow">
            <KnowledgeDialog :knowledgeData="courseInfo.knowledge_map" v-if="knowledgeVisible"
                             :knowledgeVisible="knowledgeVisible"
                             @showKnowledge="showKnowledge"></KnowledgeDialog>
        </el-dialog>
        <FishDialog :fishData="courseInfo.fishbone_map" :fishVisible="fishVisible" v-if="fishVisible"
                    @showFish="showFish"></FishDialog>
    </div>
</template>

<script>
    import FishDialog from "../../teacherCourse/component/FishDialog";
    import KnowledgeDialog from "../../teacherCourse/component/KnowledgeDialog";

    export default {
        name: "CourseIndex",
        props: ['courseInfos'],
        components: {
            FishDialog,
            KnowledgeDialog,
        },
        data() {
            return {
                courseInfo: {
                    course_id: "",//课程id
                    contnet_description: "",//内容介绍
                    jx_standard: "",//教学标准
                    resource_type: "",//资源类型
                    wk_introductory: "",//微课简介
                    sx_introductory: "",//实训简介
                    correlation_course: [],//相关课程
                    fishbone_map: [],//鱼骨图json
                    knowledge_map: [],//知识图谱json
                    files_data: [],//文件json
                },
                imgArr: [{
                    src: require('../../../assets/teacherIcon/course-standard.png')
                }, {
                    src: require('../../../assets/teacherIcon/evaluation-scheme.png')
                }, {
                    src: require('../../../assets/teacherIcon/course-outline.png')
                }, {
                    src: require('../../../assets/teacherIcon/course-teach.png')
                }, {
                    src: require('../../../assets/teacherIcon/course-check.png')
                }, {
                    src: require('../../../assets/teacherIcon/course-calendar.png')
                }, {
                    src: require('../../../assets/teacherIcon/feedback-manual.png')
                }, {
                    src: require('../../../assets/teacherIcon/feedback-form.png')
                }, {
                    src: require('../../../assets/teacherIcon/lab-report.png')
                }, {
                    src: require('../../../assets/teacherIcon/evaluation.png')
                }, {
                    src: require('../../../assets/teacherIcon/left1.png')
                }, {
                    src: require('../../../assets/teacherIcon/left2.png')
                }, {
                    src: require('../../../assets/teacherIcon/left3.png')
                },],
                fishVisible: false,
                knowledgeVisible: false,
                course_video: [],
                classObject:{
                    class_name:"",
                    class_id:void 0,
                    progress:0,
                    invitation_code:"",
                    s_num:0,
                    task_num:0

                }
            }
        },
        watch: {
            courseInfos(d) {
                this.courseInfo = {
                    course_id: "",//课程id
                    contnet_description: "",//内容介绍
                    jx_standard: "",//教学标准
                    resource_type: "",//资源类型
                    wk_introductory: "",//微课简介
                    sx_introductory: "",//实训简介
                    correlation_course: [],//相关课程
                    fishbone_map: [],//鱼骨图json
                    knowledge_map: [],//知识图谱json
                    files_data: [],//文件json
                },
                    this.course_video = [],
                    this.getCourseContent();
                    this.getSelectClassInfo()
            }
        },
        mounted() {
            if(this.courseInfos.course_id !== undefined){
                this.getCourseContent();
                this.getSelectClassInfo()
            }
            
          
        },
        methods: {
            getCourseContent() {
                let param = {
                    course_id: this.courseInfos.course_id
                }
                this.$shttp.axiosGetBy(this.$api.contents_showCourseContent, param, res => {
                    if (res.code === 200) {
                        this.courseInfo.contnet_description = res.data.contnet_description;
                        this.courseInfo.jx_standard = res.data.jx_standard;
                        this.courseInfo.resource_type = res.data.resource_type;
                        this.courseInfo.wk_introductory = res.data.wk_introductory;
                        this.courseInfo.sx_introductory = res.data.sx_introductory;
                        this.courseInfo.correlation_course = res.data.correlation_course.split(',').map(Number);
                        this.courseInfo.fishbone_map = JSON.parse(res.data.fishbone_map);
                        this.courseInfo.knowledge_map = JSON.parse(res.data.knowledge_map);
                        this.courseInfo.files_data = res.data.files_data;
                        this.formatFile();
                    } else {
                        // this.$message.warning(res.msg)
                    }
                })
            },
            viewFile(item) {
                let url = item.file_path.url;
                window.open(url, '_blank')
            },
            formatFile() {
                let arr = []
                //去除没有文件的
                this.courseInfo.files_data.forEach((item, index) => {
                    item.id = index + 1;
                    if (item.file_name) {
                        arr.push(item)
                    }
                })
                this.courseInfo.files_data = arr;
                this.formatShowData();
                let countLen = 0;
                if (this.courseInfo.fishbone_map.length > 0) {
                    countLen += 1;
                }
                if (this.courseInfo.knowledge_map.length > 0) {
                    countLen += 1;
                }
                let len = this.courseInfo.files_data.length
                switch (countLen) {
                    case 0:
                        this.courseInfo.files_data.forEach((item, index) => {
                            if (index < 2) {
                                item.class = 'row1'
                            }
                            if (len > 10) {
                                if (index > 1) {
                                    item.class = 'row4'
                                }
                            } else {
                                if (index > 1) {
                                    item.class = 'row3'
                                }
                            }
                        })
                        break;
                    case 1:
                        this.courseInfo.files_data.forEach((item, index) => {
                            if (index < 1) {
                                item.class = 'row1'
                            }
                            if (len > 9) {
                                if (index > 0) {
                                    item.class = 'row4'
                                }
                            } else {
                                if (index > 0) {
                                    item.class = 'row3'
                                }
                            }
                        })
                        break;
                    case 2:
                        this.courseInfo.files_data.forEach((item, index) => {
                            if (len > 8) {
                                item.class = 'row4'
                            } else {
                                item.class = 'row3'
                            }
                        })
                        break;
                }
            },
            formatShowData() {
                if (this.courseInfo.files_data.length > 0 && this.courseInfo.files_data[0].id === 1) {
                    this.course_video.push(this.courseInfo.files_data[0]);
                    this.courseInfo.files_data.splice(0, 1)
                }
                this.courseInfo.files_data.forEach((item, index) => {
                    switch (item.id) {
                        case 2:
                            item.src = require('../../../assets/teacherIcon/fish-bone.png');
                            break;
                        case 3:
                            item.src = require('../../../assets/teacherIcon/knowledge-domain.png');
                            break;
                        case 4:
                            item.src = require('../../../assets/teacherIcon/course-teach.png');
                            break;
                        case 5:
                            item.src = require('../../../assets/teacherIcon/course-calendar.png');
                            break;
                        case 6:
                            item.src = require('../../../assets/teacherIcon/left2.png');
                            break;
                        case 7:
                            item.src = require('../../../assets/teacherIcon/course-check.png');
                            break;
                        case 8:
                            item.src = require('../../../assets/teacherIcon/course-outline.png');
                            break;
                        case 9:
                            item.src = require('../../../assets/teacherIcon/evaluation-scheme.png');
                            break;
                        case 10:
                            item.src = require('../../../assets/teacherIcon/course-standard.png');
                            break;
                        case 11:
                            item.src = require('../../../assets/teacherIcon/left3.png');
                            break;
                        case 12:
                            item.src = require('../../../assets/teacherIcon/evaluation.png');
                            break;
                        case 13:
                            item.src = require('../../../assets/teacherIcon/feedback-manual.png');
                            break;
                        case 14:
                            item.src = require('../../../assets/teacherIcon/feedback-form.png');
                            break;
                        case 15:
                            item.src = require('../../../assets/teacherIcon/left3.png');
                            break;
                    }
                })
            },
            viewCourseDetail() {
                this.$shttp.axiosGetBy(this.$api.contents_showCourseContent, {course_id: this.$route.query.course_id}, (res) => {
                    if (res.code === 200) {
                        if (res.data.contnet_description === '' &&
                            res.data.jx_standard === '' &&
                            res.data.resource_type === '' &&
                            res.data.wk_introductory === '' &&
                            res.data.sx_introductory === '' &&
                            res.data.correlation_course_data.length === 0) {
                            return this.$message.warning('FAIL!该课程暂无首页,请联系管理员创建!')
                        }
                        this.$router.push({
                            name: 'qualityCourseDetail',
                            query: {
                                course_id: this.$route.query.course_id
                            }
                        })
                    } else {
                        this.$message.warning(res.msg)
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            viewFishBone() {
                if (this.courseInfo.fishbone_map.length == 0) {
                    this.$message.warning('暂无数据');
                    return
                }
                this.fishVisible = true;
            },
            viewKnowledge() {
                if (this.courseInfo.knowledge_map.length == 0) {
                    this.$message.warning('暂无数据');
                    return
                }
                this.knowledgeVisible = true;
            },
            showFish(val) {
                this.fishVisible = val;
            },
            showKnowledge(val) {
                this.knowledgeVisible = val;
            },
            handleCloseKnow() {
                this.knowledgeVisible = false;
            },
            getSelectClassInfo(){
                let params={
                    class_id:Number(localStorage.getItem("c_id"))
                }
                this.$http.axiosPost(this.$api.jdCourseSelectionClassInfo, params, (res) => {
                            if (res.code === 200) {
                                this.classObject.class_id=res.data.result.c_id
                                this.classObject.class_name=res.data.result.c_name
                                this.classObject.progress=res.data.result.progress
                                this.classObject.invitation_code=res.data.result.invitation_code
                                this.classObject.s_num=res.data.result.s_num
                                this.classObject.task_num=res.data.result.task_num

                               
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                });
                            }
                        }, (err) => {
                            errorData=err.response.data
                            this.$message.error(errorData.msg)
                            console.log(err)
                        })
            },
        }
    }
</script>

<style scoped lang="scss">
    ::v-deep .el-dialog {
        width: calc(100% - 120px);
        min-width: 1000px;
    }

    ::v-deep .el-dialog__header::after {
        content: '';
        width: 100%;
        height: 10px;
        display: block;
        margin: 0 auto;
        border-bottom: 1px solid #EEEEEE;
    }

    ::v-deep .el-dialog__footer {
        text-align: center;
    }

    ::v-deep .el-dialog__body {
        position: relative;
    }

    .featured-content {
        display: flex;
        justify-content: start;
        width: 100%;
        height: 100%;
        padding: 10px 100px 4px;
        box-sizing: border-box;
   
        background-color: #EFEFEF ;
       

        ::v-deep .el-dialog {
            margin-top: 10vh !important;
        }


    }
    .featured{
        width: 100%;
        height: 880px;
        padding-bottom: 30px;
        box-sizing: border-box;
        background-color: #FFFFFF;
        // overflow-y: auto;

    }

    .main{
            width: 100%;
            // height: 100% !important;
        
            // min-height: 540px;
            padding-bottom: 30px;
            box-sizing: border-box;
            background-color: #FFFFFF;
            .top-box {
                width: 100%;
                // height: 50%;
                min-height: 440px;
                // background: linear-gradient(153deg, #ECF6FF, #F0F3FF);
                display: flex;
                /*flex: 1;*/

                .top-leftBox {
                    width: 586px;
                    height: 330px;
                    padding: 60px 30px 32px 60px;

                    img {
                        max-height: 100%;
                        max-width: 100%;
                    }
                }

                .top-rightBox {
                    height: 330px;
                    padding: 60px 60px 32px 0;
                    box-sizing: border-box;

                    .rightBox-course {
                        // display: flex;
               
                        // margin-top: 30px;
                        // background-color: pink;

                        .course-title-box1 {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: bold;
                            font-size: 24px;
                            color: #2C3E50;
                            line-height: 28px;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                        }

                        .course-title-box2 {
                            width: 110px;
                            background-image: url("../../../assets/images/courseIndex.png");
                            margin-left: 30px;
                            text-align: center;
                            color: #FFFFFF;
                            height: 30px;

                            i {
                                margin-right: 8px;
                                font-size: 14px;
                            }
                        }

                        .course-title-midBox {
                            margin-top: 20px;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: bold;
                            font-size: 14px;
                            color: #2C3E50;
                            max-width: 700px;
                            max-height: 30px;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 7;

                            span {
                                font-size: 14px;
                                word-break: break-all;
                                line-height: 25px;
                                max-height: 120px;
                                font-weight: 500;
                            }
                        }
                        .course-title-midBox1{
                            max-height: 230px !important;
                            // background-color: pink;
                        }
                    }
                }
            }

            .bottom-box {
                width: 100%;
                // min-height: 360px;
                box-sizing: border-box;
                // background-color: pink;

                .course-list {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    // padding: 29px 172px 63px;
                    padding: 0 60px;
                    box-sizing: border-box;
                    // background-color: skyblue;
                    //
             

                    .list-item {
                        cursor: pointer;
                        width: 270px;
                        height: 90px;
                        background-color:#F2F6FA ; 
                        // box-shadow: 0px 5px 17px 3px rgba(9, 95, 185, 0.1);
                        border-radius: 6px 6px 6px 6px;
                        border: 1px solid #E1E6F0;
                        display: flex;
                        align-items: center;
                        margin-right: 20px;
                        margin-top: 20px;

                        // &:nth-of-type(4n) {
                        //     margin-right: 0;
                        // }

                        // &:nth-of-type(4) {
                        //     margin-top: 0 !important;
                        // }

                        img {
                            width: 60px;
                            height: 60px;
                            margin-left: 26px;
                        }

                        span {
                            margin-left: 20px;
                        }

                        // &.row3 {
                        //     margin-top: 80px;

                        // }

                        // &.row4 {
                        //     margin-top: 20px;
                        // }
                    }
                }
            }
           }


           .el-scrollbar{
            ::v-deep .el-scrollbar__wrap{
                overflow-x: hidden;
            }
           }
</style>